// extracted by mini-css-extract-plugin
export default {"viewLessonsMobile":"Test_viewLessonsMobile__OnCCz"};